import styled from 'styled-components';
import { Colors } from '../../colors/Colors';

export const Page = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline: 1rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  max-width: ${({ hasReviews }) => (hasReviews ? '1216px' : '720px')};
  width: 100%;
  margin-top: 10rem;
  padding-bottom: 20rem;
`;

export const Header = styled.h1`
  color: ${Colors.accent1};
  font-family: 'Poppins' !important;
  font-size: 48px;
  font-weight: 900;
`;

export const Text = styled.p`
  color: ${Colors.accent1};
  font-family: 'Roboto' !important;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
  max-width: 720px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  resize: none;
  height: 142px;
  border: none;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 1.5rem 2rem;
  font-family: 'Roboto';
  font-size: 16px;

  &::placeholder {
    color: #999692;
  }
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: ${Colors.accent2};
  color: white;
  border: none;
  font-size: 20px;
  font-weight: 400;
  padding: 0.8rem 5rem;
  border-radius: 999px;
  font-family: 'Roboto';
  cursor: pointer;
`;

export const ReviewsGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 24px;
  width: 100%;
  padding-top: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 600px) {
    gap: 16px;
    padding-top: 1rem;
  }
`;

export const ReviewCard = styled.article`
  background: white;
  border: 1px solid #f3f4f6;
  border-radius: 24px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  grid-column: span 3;

  ${({ isLarge }) => isLarge && 'grid-column: span 6;'}
  ${({ isTall }) => isTall && 'grid-row: span 2;'}

  @media (max-width: 1024px) {
    grid-column: span 1;
    ${({ isLarge }) => isLarge && 'grid-column: span 2;'}
    ${({ isTall }) => isTall && 'grid-row: span 1;'}
  }

  @media (max-width: 640px) {
    grid-column: span 1 !important;
    grid-row: span 1 !important;
  }

  @media (max-width: 600px) {
    padding: 20px;
    gap: 12px;
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: rgba(139, 90, 43, 0.08);
  padding: 4px 10px;
  border-radius: 999px;
  align-self: flex-start;
`;

export const StarIcon = styled.img`
  width: 12px;
  height: 12px;
`;

export const BadgeText = styled.span`
  color: #8b5a2b;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
`;

export const ReviewText = styled.p`
  && {
    color: ${({ isDark }) => (isDark ? '#2c1600' : '#374151')};
    font-family:
      ${({ isDark }) => (isDark ? "'Plus Jakarta Sans'" : "'Inter'")},
      sans-serif;
    font-weight: ${({ isDark }) => (isDark ? '700' : '400')};
    font-size: ${({ isDark }) => (isDark ? '18px' : '14px')};
    line-height: ${({ isDark }) => (isDark ? '1.5' : '1.6')};
    margin: 0;
  }
`;
